'use client';

import { useTransition } from 'react';

import { Bookmark } from 'lucide-react';

import { useToggleBookmarkMessage } from '../../hooks/useToggleBookmarkMessage';

interface Props {
  channelId: string;
  messageId: string;
}

/**
 * Filled bookmark badge shown in a message header when the current user has
 * bookmarked that message (mirrors PopshopRN's header `BookmarkIcon`). Clicking
 * it removes the bookmark. Only rendered by the bubble when the message is
 * bookmarked, so the click always un-bookmarks.
 */
export function MessageBookmarkIndicator({ channelId, messageId }: Props) {
  const toggleBookmark = useToggleBookmarkMessage({ channelId, messageId });
  const [pending, startTransition] = useTransition();

  const onRemove = () => {
    if (pending) return;
    startTransition(async () => {
      try {
        await toggleBookmark({ currentlyBookmarked: true });
      } catch (error) {
        console.error('remove channel message bookmark failed', error);
      }
    });
  };

  return (
    <button
      type="button"
      onClick={onRemove}
      disabled={pending}
      aria-label="Remove bookmark"
      className="text-brand-text hover:text-brand-hover disabled:opacity-60"
    >
      <Bookmark className="h-4 w-4 fill-current" aria-hidden />
    </button>
  );
}
